import {whenAppears} from "./whenAppears.js"

export const stats_counter = function() {

    whenAppears('.fcwp-stats', function(element) {
        var wrapper = element.closest('.wp-block-group__inner-container');
        if (wrapper) {
            wrapper.classList.add('row');
        }
        var bar = element.querySelector('.stats-bar');
        var counter = element.querySelector('.stats-number')
        var number = counter.innerHTML;
        var jump = Math.floor(number / 50);
        jump = jump == 0 ? 1 : jump;
        var bar_increase = 40 / number * jump;
        var bar_length = number == 0 ? 40 : 0;
        let count = 0;
        const time = setInterval(function() {
            if (count >= number) {
                count = number;
                bar.style.width = bar_length + '40%';
                clearInterval(time);
            }
            bar.style.width = bar_length + '%';
            counter.textContent = count;
            count += jump;
            bar_length += bar_increase;

        }, 50);
    });

    whenAppears('.progress-bar-wrapper', function(element) {
        
        var fill = element.querySelector('.progress-fill');
        var bar_width = element.querySelector('.progress-bar').offsetWidth;
        var fill_width = fill.getAttribute('val') * bar_width / 100;
        var fill_jump = fill_width / 50;
        var current_width = 0;

        var number = element.querySelector('.value-number');
        var number_value = number.getAttribute('val');
        var number_jump = number_value / 50;
        var current_number = 0;

        var number_wrapper = element.querySelector('.progress-no');
        var number_wrapper_width = 0;

        var description = element.querySelector('.progress-description');
        
        const time = setInterval(function(){
            if (current_width >= fill_width) {
                fill.style.width = fill_width + 'px';
                number.innerHTML = number_value;
                description.style.opacity = 1;
                clearInterval(time);
                return;
            }
            fill.style.width = current_width + 'px';
            current_width += fill_jump;

            number.innerHTML = current_number.toFixed(2);
            current_number += number_jump;
            
            number_wrapper.style.left = getLeft(current_width) + 'px';


        }, 50);

        var getLeft = function(width) {
            number_wrapper_width = number_wrapper.offsetWidth;
            if (width < number_wrapper_width / 2) return 0;
            if (width + number_wrapper_width >= bar_width) return bar_width - number_wrapper_width;
            return width - number_wrapper_width / 2;
        }

    });

}